import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { ReactTyped as Typed } from "react-typed";
import ParticlesBg from "particles-bg";

import mirik from "./mirik.jpg";

import Projects from "../Projects";
import Articles from "../Articles"
import Youtube from "../Youtube";
import Skills from "../Skills";
import Gallery from "../Gallery"
import Contact from "../Contact"
import ChefCorner from "../ChefCorner"
import BooksIRead from "../BooksIRead"
import FavQuotes from "../FavQuotes"
import MyThoughts from "../MyThoughts"
import Section from "../Section";
import { useLocation, useNavigate } from 'react-router-dom'
import scrollToSection from '../../util/scrollToSection'


// MUI v5: use `sx` props instead of makeStyles. Define style objects below.
const titleSx = { color: 'white' };
const subtitleSx = { color: 'white', textTransform: 'uppercase' };
const typedContainerSx = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%,-50%)',
  width: '100vw',
  textAlign: 'center',
  zIndex: 1,
};
const typedContainerMobileSx = {
  position: 'absolute',
  top: '32%',
  left: '50%',
  transform: 'translate(-50%,-50%)',
  width: '100vw',
  textAlign: 'center',
  zIndex: 1,
  padding: '0 16px',
  boxSizing: 'border-box',
};

const myImage = {
  backgroundImage: "url(" + mirik + ")",
  backgroundColor: "#346794",
  backgroundPosition: "center",
  backgroundSize: "100% 100%",
  backgroundRepeat: "no-repeat",
  height: "80vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%) ",
  backgroundBlendMode: "multiply",
};
const myImageMobile = {
  backgroundImage: "url(" + mirik + ")",
  backgroundColor: "#346794",
  backgroundPosition: "center",
  backgroundSize: "100% 50%",
  backgroundRepeat: "no-repeat",
  height: "50vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%) ",
  backgroundBlendMode: "multiply",
};

const Home = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  // Scroll to a section if navigation provided a target in location.state
  useEffect(() => {
    if (location && location.state && location.state.scrollTo) {
      const target = location.state.scrollTo
      // small delay to ensure elements are mounted
      const timeoutId = setTimeout(() => scrollToSection(target), 300)
      // Clear the state to avoid re-scrolling on future navigations/back
      try {
        window.history.replaceState({}, document.title, window.location.pathname)
      } catch (e) {
        // ignore
      }
      return () => clearTimeout(timeoutId)
    }
  }, [location])

  return (
    <div>
  <Section id="home" className="section section--accent scroll-anchor" style={windowWidth >= 650 ? myImage : myImageMobile} wave={false}>
        <div>
          <Box
            sx={windowWidth >= 650 ? typedContainerSx : typedContainerMobileSx}
          >
            <Box
              component="img"
              src="/javedinfinte-transparent-logo.png"
              alt="javedinfinite"
              loading="lazy"
              decoding="async"
              fetchpriority="low"
              sx={{
                display: "block",
                width: { xs: 210, sm: 280 },
                maxWidth: "80vw",
                height: "auto",
                mx: "auto",
                mb: 1,
                objectFit: "contain",
              }}
            />
            <Typography sx={titleSx} variant="h5">
              <Typed strings={["Javed Akhtar ∞"]} typeSpeed={40} />
            </Typography>

            <Typography sx={subtitleSx} variant="h7">
              <Typed
                strings={[
                  "Frontend Developer - React",
                  "Backend Developer - Node",
                  "Full Stack Developer",
                  "AWS Experienced"
                ]}
                typeSpeed={40}
                backSpeed={50}
                loop
              />
            </Typography>
            <Typography variant="body2" sx={{ mt: 1, color: 'rgba(255,255,255,0.9)' }}>
              Free templates · Live PDF preview · No account required
            </Typography>
            <Button
              variant="contained"
              onClick={() => navigate('/create-resume')}
              sx={{ mt: 2, color: '#0b3d5c', backgroundColor: '#fff', '&:hover': { backgroundColor: '#e7f3fb' }, textTransform: 'none', fontWeight: 700 }}
            >
              Build your resume free
            </Button>
          </Box>
        </div>
        <ParticlesBg type="cobweb" bg={true} />
      </Section>

      <Section id="contact" className="section section--light scroll-anchor" wave={false}>
        <div className="inner">
          <Contact />
        </div>
      </Section>

      <Section id="articles" className="section section--alt" topColor="#fbfcff" bottomColor="#bcf2f1" waveProps={{ variant: 'contact-articles' }}>
        <div className="inner">
          <Articles />
        </div>
      </Section>

      <Section id="skills" className="section section--alt" topColor="#bcf2f1" bottomColor="#ffffff" waveProps={{ variant: 'projects-skills' }}>
        <div className="inner">
          <Skills />
        </div>
      </Section>

      <Section id="youtube" className="section section--light" topColor="#ffffff" bottomColor="#dbf5f0" waveProps={{ variant: 'skills-youtube' }}>
        <div className="inner">
          <Youtube />
        </div>
      </Section>

      <Section id="projects" className="section section--light" topColor="#dbf5f0" bottomColor="#033736" waveProps={{ variant: 'articles-projects' }}>
        <div className="inner">
          <Projects />
        </div>
      </Section>

      <Section id="gallery" className="section section--alt" topColor="#033736" bottomColor="#050a30" waveProps={{ variant: 'youtube-gallery' }}>
        <div className="inner">
          <Gallery />
        </div>
      </Section>

      <Section id="chefcorner" className="section section--light" topColor="#050a30" bottomColor="#dbf5f0" waveProps={{ variant: 'gallery-chef' }}>
        <div className="inner">
          <ChefCorner />
        </div>
      </Section>

      <Section id="books" className="section section--alt" topColor="#dbf5f0" bottomColor="#0c2d48" waveProps={{ variant: 'chef-books' }}>
        <div className="inner">
          <BooksIRead />
        </div>
      </Section>

      <Section id="favquotes" className="section section--alt" topColor="#0c2d48" bottomColor="#a4e5e0" waveProps={{ variant: 'books-favquotes' }}>
        <div className="inner">
          <FavQuotes />
        </div>
      </Section>

      <Section id="mythoughts" className="section section--alt" topColor="#a4e5e0" bottomColor="#37beb0" waveProps={{ variant: 'favquotes-mythoughts' }}>
        <div className="inner">
          <MyThoughts />
        </div>
      </Section>
    </div>
  );
};
export default Home;
